import withIcon from './NewIcon';
// @ts-ignore
import IconSearch from './icon/m/search.s.svg';

export default withIcon(IconSearch);
